'use client';

import Link from '@eliadmin/core/src/components/link';

import { SignInDialog } from "@eliadmin/core/src/components/dialog/lazy-dialogs";
import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-providers-cache';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

import { MdOutlineAccountCircle } from 'react-icons/md';

export const HeaderProfileButton = () => {
  const me = useCustomerStore(s => s.me);
  const locale = useLocaleStore(s => s.currentLocale);

  const openDialog = useDialogStore(s => s.open);

  const warmSocialAuthProviders = () => {
    void prefetchSocialAuthProviders(locale);
  };

  const handleSignInClick = () => {
    warmSocialAuthProviders();
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  if (me)
    return (
      <Link prefetch={false} href={ROUTES.PROFILE()}>
        <MdOutlineAccountCircle size={24} />
      </Link>
    );

  return (
    <div className="cursor-pointer" onClick={handleSignInClick}>
      <MdOutlineAccountCircle size={24} />
    </div>
  );
};
